import { makeStyles } from '@material-ui/core/styles'
import { createStyles, Theme } from '@material-ui/core'
import { layoutContentMaxWidthPx } from '../../../shared/style-settings'

export const useDraftEditorStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      paddingLeft: 20,
      paddingRight: 20,
      paddingTop: 20,
      margin: '0 auto',
      marginTop: '10px',
      maxWidth: layoutContentMaxWidthPx,
      [theme.breakpoints.down('sm')]: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingTop: theme.spacing(1.5),
        marginTop: 0,
      },
    },
    //Header
    header: {
      paddingLeft: 0,
      paddingRight: 0,
      textAlign: 'left',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    headerMobile: {},
    formContainer: {
      padding: 30,
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(1),
      },
    },
    inputHolder: {
      marginBottom: 20,
      [theme.breakpoints.down('sm')]: {
        marginBottom: theme.spacing(1.5),
      },
    },
    shippingAddressAlert: {
      paddingTop: 20,
      [theme.breakpoints.down('sm')]: {
        paddingTop: theme.spacing(1),
      },
    },
    headerTitle: {
      position: 'relative',
      display: 'inline-block',
      marginRight: 'auto',
    },

    btnHolder: {
      display: 'flex',
      gap: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        width: '100%',
        '& .MuiButton-root': {
          minWidth: 0,
          width: '100%',
          paddingLeft: theme.spacing(1),
          paddingRight: theme.spacing(1),
        },
      },
    },

    cancelBtn: {
      marginLeft: 'auto',
      marginRight: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        marginLeft: 0,
        marginRight: 0,
      },
    },

    loading: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      top: '40%',
      left: '50%',
      zIndex: 1,
    }
  })
)
